export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant03-mobile-de.a95e72b8.png";